import React from 'react';
import { CategoryFilterItem } from './CategoryFilterItem';

export class CategoryFilter extends React.Component {
	renderFilterItems() {
		return this.props.filters.map(filter => {
			return <CategoryFilterItem key={filter.filterId} filter={filter} filterById={this.props.filterDiscoverElementsHandler}/>
		});
	}

	filterByName = (filterName) => {
		this.props.filterCategoryName(filterName);
	}

	render() {
		const renderedFilterItems = this.renderFilterItems();

		return (
			<ul className="clearfix discover__filter">
				{ renderedFilterItems }
			</ul>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Discover/CategoryFilter.js